<!-- 类table的列表图 -->
<style lang="stylus" scoped>
.table
  width 100%
  height 100%
  background url('../../../../../assets/img/trp/left1.png')
  background-size 100% 100%
  .main
    // border: 1px red solid;
    padding 10px
    padding-top 50px
    li
      height 40px
      width 90%
      margin 0 auto
      // border: 1px #FFF solid;
      margin-bottom 10px
      span
        height 18px
        font-size 18px
        font-weight 400
        line-height 40px
        color rgba(255, 255, 255, 1)
        float left
        margin-right 10px
        img
          height 25px
          width 25px
          margin 7.5px
      span:nth-child(2)
        width 40%
      span:nth-child(3)
        width 30%
        margin-right 10px
        .count
          color #fff
          position absolute
          letter-spacing 23px
          text-align right
          width 113px
        div
          width 30px
          height 40px
          background #1849AA
          margin-right 5px
          float left
          font-size 20px
          font-weight 400
          line-height 40px
          text-align center
          color rgba(255, 255, 255, 1)
</style>

<template>
  <div class="table">
    <ul class="main">
      <li>
        <span><img src="../../../../../assets/img/trp/icon1.png" /></span>
        <span>经营主体入网数</span>
        <span>
          <countTo class="count"
                   :startVal='0'
                   :endVal='990'
                   :duration='5000'></countTo>
          <div></div>
          <div></div>
          <div></div>

        </span>
        <span>家</span>
      </li>
      <li>
        <span><img src="../../../../../assets/img/trp/icon2.png" /></span><span>待审核经营主体</span>
        <span>
          <countTo class="count"
                   :startVal='0'
                   :endVal='10'
                   :duration='5000'></countTo>
          <div></div>
          <div></div>
          <div></div>
        </span>
        <span>家</span>
      </li>
      <li>
        <span><img src="../../../../../assets/img/trp/icon3.png" /></span><span>经营限制农药</span>
        <span>
          <countTo class="count"
                   :startVal='0'
                   :endVal='100'
                   :duration='5000'></countTo>
          <div></div>
          <div></div>
          <div></div>
        </span>
        <span>家</span>
      </li>
      <li>
        <span><img src="../../../../../assets/img/trp/icon4.png" /></span><span>批发商</span>
        <span>
          <countTo class="count"
                   :startVal='0'
                   :endVal='100'
                   :duration='5000'></countTo>
          <div></div>
          <div></div>
          <div></div>
        </span>
        <span>家</span>
      </li>
      <li>
        <span><img src="../../../../../assets/img/trp/icon5.png" /></span><span>零售商</span>
        <span>
          <countTo class="count"
                   :startVal='0'
                   :endVal='100'
                   :duration='5000'></countTo>
          <div></div>
          <div></div>
          <div></div>
        </span><span>家</span>
      </li>
      <li>
        <span><img src="../../../../../assets/img/trp/icon6.png" /></span><span>店铺交易活跃</span>
        <span>
          <countTo class="count"
                   :startVal='0'
                   :endVal='800'
                   :duration='5000'></countTo>
          <div></div>
          <div></div>
          <div></div>
        </span>
        <span>家</span>
      </li>
    </ul>
  </div>
</template>

<script>
import boxWrap from '../common/boxWrap';
// import '/../../../../static/css/swiper.css'
import '@/assets/css/swiper.css'
import countTo from 'vue-count-to';

import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  props: ['salesDataRealTime'],
  data () {
    return {
      name: '产业情况',
      tableData: [],
      swiperOption: {
        slidesPerView: 'auto',
        // 是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        // 循环
        loop: true,
        // 设定初始化时slide的索引
        initialSlide: 0,
        roundLengths: true,
        height: 100,
        // 自动播放
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          /* 触摸滑动后是否继续轮播 */
          disableOnInteraction: false
        },
        // autoplay: false,
        // 滑动速度
        speed: 800,
        // 滑动方向
        direction: "vertical",
        // 小手掌抓取滑动
        grabCursor: true
      },
      colorList: ["#f1641e", "#f1c21e", "#69ba32", "#0092ee"]
    }
  },
  methods:
  {
    changeColor (index) {
      if (index <= 3) {
        return `color:${this.colorList[index]}`;
      } else {
        return `color:${this.colorList[3]}`;
      }
    }
  },
  components: {
    boxWrap,
    swiper,
    swiperSlide,
    countTo
  },
  mounted () {
    this.tableData = [{ name: '安吉乡土农业发展有限公司', orderNumber: '农业管理', lumpSum: '良好' },
    { name: '安吉知竹家居有限公司', orderNumber: '加工业', lumpSum: '良好' },
    { name: '安吉盈元家庭农场', orderNumber: '农业种植', lumpSum: '良好' },
    { name: '安吉润发家庭农场有限公司', orderNumber: '农业种植', lumpSum: '良好' },
    { name: '安吉阿福家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好' },
    { name: '安吉龙龙家庭农场有限公司', orderNumber: '加工业', lumpSum: '良好' }]
  }
}

</script>


// WEBPACK FOOTER //
// index.vue?19f4d788